<template>
  <q-form ref="editForm">
    <c-card title="감사계획 상세" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn v-if="editable && !param.disabled" label="계획완료" icon="assignment_turned_in" color="red" />
          <c-btn v-if="editable && !param.disabled" label="임시저장" icon="save" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-text
            :required="true"
            :editable="editable"
            :disabled="param.disabled"
            label="감사명"
            name="col1"
            v-model="info.col1">
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            type="year"
            label="감사년도"
            name="col2"
            v-model="info.col2"
          />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :required="true"
            :editable="editable"
            :disabled="param.disabled"
            :comboItems="col1Items"
            type="edit"
            itemText="codeName"
            itemValue="code"
            name="col3"
            label="감사종류"
            v-model="info.col3"
          ></c-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-plant
            :required="true"
            :disabled="param.disabled"
            :editable="editable"
            type="edit"
            name="plantCd"
            v-model="info.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-card title="감사대상" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-12">
                <c-text
                  :editable="editable"
                  label="감사대상개요"
                  name="col4"
                  v-model="info.col4">
                </c-text>
              </div>
              <div class="col-4">
                <c-table
                  ref="grid1"
                  title="대상공정"
                  tableId="grid1"
                  :columns="grid1.columns"
                  :data="grid1.data"
                  selection="multiple"
                  rowKey="col1"
                  :isFullScreen="false"
                  :columnSetting="false"
                  :filtering="false"
                  :usePaging="false"
                  :hideBottom="true"
                  gridHeight="300px"
                >
                  <!-- 버튼 영역 -->
                  <template slot="table-button">
                    <q-btn-group outline >
                        <c-btn v-if="editable" icon="add" @btnClicked="addrow1" />
                        <c-btn v-if="editable" icon="save" />
                        <c-btn v-if="editable" icon="remove" @btnClicked="removerow1" />
                    </q-btn-group>
                  </template>
                </c-table>
              </div>
              <div class="col-4">
                <c-table
                  ref="grid2"
                  title="대상설비"
                  tableId="grid2"
                  :columns="grid2.columns"
                  :data="grid2.data"
                  selection="multiple"
                  rowKey="col1"
                  :isFullScreen="false"
                  :columnSetting="false"
                  :filtering="false"
                  :usePaging="false"
                  :hideBottom="true"
                  gridHeight="300px"
                >
                  <!-- 버튼 영역 -->
                  <template slot="table-button">
                    <q-btn-group outline >
                        <c-btn v-if="editable" icon="add" @btnClicked="addrow2" />
                        <c-btn v-if="editable" icon="save" />
                        <c-btn v-if="editable" icon="remove" @btnClicked="removerow2" />
                    </q-btn-group>
                  </template>
                </c-table>
              </div>
              <div class="col-4">
                <c-table
                  ref="grid3"
                  title="대상부서"
                  tableId="grid3"
                  :columns="grid3.columns"
                  :data="grid3.data"
                  selection="multiple"
                  rowKey="col1"
                  :isFullScreen="false"
                  :columnSetting="false"
                  :filtering="false"
                  :usePaging="false"
                  :hideBottom="true"
                  gridHeight="300px"
                >
                  <!-- 버튼 영역 -->
                  <template slot="table-button">
                    <q-btn-group outline >
                        <c-btn v-if="editable" icon="add" @btnClicked="addrow3" />
                        <c-btn v-if="editable" icon="save" />
                        <c-btn v-if="editable" icon="remove" @btnClicked="removerow3" />
                    </q-btn-group>
                  </template>
                </c-table>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-card title="감사수행일정" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-12">
                <c-datepicker
                  :required="true"
                  :editable="editable"
                  :disabled="param.disabled"
                  :range="true"
                  label="감사기간"
                  name="col5"
                  v-model="info.col5"
                />
              </div>
              <div class="col-12">
                <c-table
                  ref="grid4"
                  title="일자별 수행내역"
                  tableId="grid4"
                  :columns="grid4.columns"
                  :data="grid4.data"
                  selection="multiple"
                  rowKey="col1"
                  :isFullScreen="false"
                  :columnSetting="false"
                  :filtering="false"
                  :usePaging="false"
                  :hideBottom="true"
                  gridHeight="300px"
                >
                  <!-- 버튼 영역 -->
                  <template slot="table-button">
                    <q-btn-group outline >
                        <c-btn v-if="editable" icon="add" @btnClicked="addrow4" />
                        <c-btn v-if="editable" icon="save" />
                        <c-btn v-if="editable" icon="remove" @btnClicked="removerow4" />
                    </q-btn-group>
                  </template>
                </c-table>
              </div>
            </template>
          </c-card>
        </div>
      </template>
    </c-card>
  </q-form>
</template>

<script>
export default {
  name: 'hazop-plan-info',
  props: {
    param: {
      type: Object,
      default: () => ({
        disabled: false,
      }),
    },
  },
  data() {
    return {
      info: {
        plantCd: null,
        col1: '',
        col2: '',
        col3: null,
        col4: '',
        col5: [],
        col6: '',
        col7: '',
        col8: '',
        col9: '',
      },
      editable: true,
      searchUrl: '',
      col1Items: [
        { code: "1", codeName: "정기자체감사" },
        { code: "2", codeName: "특별자체감사" },
        { code: "3", codeName: "외부감사" },
      ],
      grid1: {
        columns: [
          {
            name: 'col2',
            field: 'col2',
            label: '공정명',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
      grid2: {
        columns: [
          {
            name: 'col2',
            field: 'col2',
            label: '설비명',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
      grid3: {
        columns: [
          {
            name: 'col2',
            field: 'col2',
            label: '부서명',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
      grid4: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '일자',
            align: 'center',
            style: 'width: 100px',
            type: 'date',
            sortable: false,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '감사내역',
            align: 'left',
            type: 'text',
            sortable: false,
          },
          {
            name: 'col3',
            field: 'col3',
            label: '참석자',
            align: 'left',
            type: 'text',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.info = {
        plantCd: '1',
        col1: '정기 자체감사',
        col2: '2021',
        col3: '1',
        col4: '감사대상 개요내용',
        col5: ['2021-03-21','2021-03-30'],
        col6: '',
        col7: '',
        col8: '',
        col9: '',
      };
      this.getTaget1();
      this.getTaget2();
      this.getTaget3();
      this.getTaget4();
    },
    getTaget1() {
      this.grid1.data = [
        {
          col1: 'PROC000001',
          col2: '건조공정',
        },
        {
          col1: 'PROC000002',
          col2: '반응공정',
        },
      ]
    },
    getTaget2() {
      this.grid2.data = [
        {
          col1: 'LS-01-2132',
          col2: '반응기A',
        },
        {
          col1: 'BF-03-9821',
          col2: '반응기B',
        },
      ]
    },
    getTaget3() {
      this.grid3.data = [
        {
          col1: 'DEPT00001',
          col2: '생산1팀',
        },
        {
          col1: 'DEPT00002',
          col2: '공무팀',
        },
        {
          col1: 'DEPT00003',
          col2: '환경팀',
        },
      ]
    },
    getTaget4() {
      this.grid4.data = [
        {
          col1: '2021-03-24',
          col2: '감사내용 정리',
          col3: '홍길동, 김현철',
        },
      ]
    },
    addrow1() {
    },
    removerow1() {
      let selectData = this.$refs['grid1'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.grid1.data = this.$_.reject(this.grid1.data, { col1: item.col1 })
        })
      }
    },
    addrow2() {
    },
    removerow2() {
      let selectData = this.$refs['grid2'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.grid2.data = this.$_.reject(this.grid2.data, { col1: item.col1 })
        })
      }
    },
    addrow3() {
    },
    removerow3() {
      let selectData = this.$refs['grid3'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.grid3.data = this.$_.reject(this.grid3.data, { col1: item.col1 })
        })
      }
    },
    addrow4() {
      this.grid4.data.splice(0, 0, {
        col1: '',
        col2: '',
        col3: '',
      })
    },
    removerow4() {
      let selectData = this.$refs['grid4'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.grid4.data = this.$_.reject(this.grid4.data, { col1: item.col1 })
        })
      }
    },
  }
};
</script>
